import { FileImageOutlined } from '@ant-design/icons';

/** 文章封面縮圖；無圖時顯示帶色塊的優雅佔位。 */
export default function CoverThumb({ url }: { url?: string | null }) {
  if (url) {
    return (
      <img
        src={url}
        alt=""
        className="h-12 w-12 rounded-lg object-cover ring-1 ring-black/5"
      />
    );
  }
  return (
    <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-[#fbf3e8] text-lg text-[#dd7900]/55 ring-1 ring-[#dd7900]/10">
      <FileImageOutlined />
    </div>
  );
}
